export default "__VITE_ASSET__C4tF_abq__"